module.exports = __webpack_public_path__ + "img/synopsis_001.d154df92.png";